import React from 'react';
import { SlidersHorizontal, Search, Plus } from 'lucide-react';
import Select, { components } from 'react-select';

class WorkspaceHeader extends React.Component {
    constructor(props) {
        super(props);
        this.filterRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (event.target && event.target.closest && event.target.closest('[class*="select-control"]')) {
            return;
        }
        if (
            this.props.showFiltersPanel &&
            this.filterRef.current &&
            !this.filterRef.current.contains(event.target)
        ) {
            this.props.toggleFilterPanel();
        }
    };

    render() {
        const { 
            searchVal, 
            onSearchChange, 
            onAddMappingClick, 
            toggleFilterPanel,
            showFiltersPanel,
            activeBusinesses,
            filterBusinesses,
            onBusinessFilterToggle,
            scopedFunctions,
            filterFunctionId,
            onFunctionFilterChange,
            filterStatus,
            onStatusFilterChange,
            clearAllFilters,
            matchingCount
        } = this.props;

        const allSelected = activeBusinesses.length > 0 && filterBusinesses.size === activeBusinesses.length;
        const isFilterActive = filterBusinesses.size > 0 || filterFunctionId !== 'all' || filterStatus !== 'all';
        const filterCount = (filterBusinesses ? filterBusinesses.size : 0) + (filterFunctionId !== 'all' ? 1 : 0) + (filterStatus !== 'all' ? 1 : 0);

        return (
            <div className="tw-bg-white dark:tw-bg-[#1E1E2D] tw-border-0 tw-border-b tw-border-solid tw-border-[#ECECEC] dark:tw-border-white/10">
                {/* Header Toolbelt Section */}
                <div className="tw-p-4 tw-flex tw-items-center tw-justify-between tw-gap-4 tw-flex-wrap">
                    <div className="tw-relative tw-flex tw-items-center tw-gap-3 tw-min-w-0" ref={this.filterRef}>
                        {/* Filters Toggle Button */}
                        <button 
                            type="button"
                            onClick={toggleFilterPanel}
                            className={`tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-border tw-border-solid tw-rounded-lg tw-transition-colors ${
                                isFilterActive || showFiltersPanel
                                    ? 'tw-text-[#2563EB] tw-bg-[#EFF6FF] tw-border-[#2563EB]'
                                    : 'tw-text-[#374151] dark:tw-text-white tw-bg-white dark:tw-bg-[#2B2B40] tw-border-[#D5D7DA] dark:tw-border-white/10 hover:tw-bg-[#F9FAFB] dark:hover:tw-bg-[#3A3A55]'
                            }`}
                        >
                            <SlidersHorizontal size={15} />
                            <span>Filter</span>
                            {filterCount > 0 && (
                                <span className={`tw-inline-flex tw-items-center tw-justify-center tw-min-w-[18px] tw-h-[18px] tw-text-[11px] tw-font-semibold tw-rounded-full tw-px-1 ${
                                    isFilterActive || showFiltersPanel
                                        ? 'tw-bg-[#2563EB] tw-text-white'
                                        : 'tw-bg-[#E4E7EC] dark:tw-bg-[#4B4B60] tw-text-[#374151] dark:tw-text-white'
                                }`}>
                                    {filterCount}
                                </span>
                            )}
                        </button>

                        {/* Filter Dropdown Panel */}
                        {showFiltersPanel && (
                            <div className="tw-absolute tw-left-0 tw-top-[calc(100%+8px)] tw-z-[60] tw-w-[240px] tw-bg-white dark:tw-bg-[#1E1E2D] tw-border tw-border-solid tw-border-[#E4E7EC] dark:tw-border-white/10 tw-rounded-xl tw-shadow-[0px_12px_40px_rgba(0,0,0,0.12)]"
                                style={{ maxHeight: '520px', display: 'flex', flexDirection: 'column', minWidth:'320px' }}
                            >
                                {/* Header */}
                                <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-pt-4 tw-pb-3">
                                    <h4 className="tw-text-[13px] tw-font-semibold tw-text-[#181D27] dark:tw-text-white tw-my-0">
                                        Filters
                                    </h4>
                                    <button 
                                        type="button"
                                        onClick={clearAllFilters}
                                        className="tw-text-[13px] tw-font-medium tw-text-[#007BFF] hover:tw-underline tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-0"
                                    >
                                        Clear all
                                    </button>
                                </div>
                                {/* Header Divider */}
                                <div className="tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB] dark:tw-border-white/10"></div>

                                {/* Scrollable Content */}
                                <div className="tw-overflow-y-auto tw-flex-1 tw-px-4" style={{ maxHeight: '380px' }}>
                                    {/* BUSINESS Section */}
                                    <div className="tw-mb-4 tw-pt-3">
                                        <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
                                            <label className="tw-text-[11px] tw-font-semibold tw-text-[#717680] dark:tw-text-[#B2B5BE] tw-uppercase tw-tracking-wider tw-mb-0">
                                                Business
                                            </label>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (allSelected) {
                                                        // Deselect all
                                                        onBusinessFilterToggle(activeBusinesses.map(b => b.id), false);
                                                    } else {
                                                        // Select all
                                                        onBusinessFilterToggle(activeBusinesses.map(b => b.id), true);
                                                    }
                                                }}
                                                className="tw-text-[11px] tw-font-medium tw-text-[#007BFF] hover:tw-underline tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-0"
                                            >
                                                {allSelected ? 'Deselect all' : 'Select all'}
                                            </button>
                                        </div>
                                        <div className="tw-overflow-y-auto tw-space-y-1" style={{ height: '150px' }}>
                                            {activeBusinesses.map(b => (
                                                <label key={b.id} className="tw-flex tw-items-center tw-gap-2.5 tw-py-[5px] tw-cursor-pointer tw-mb-0 tw-group">
                                                    <span className={`tw-w-[18px] tw-h-[18px] tw-flex tw-items-center tw-justify-center tw-rounded tw-border tw-border-solid tw-transition-colors tw-flex-shrink-0 ${
                                                        filterBusinesses.has(b.id) 
                                                            ? 'tw-bg-blue-600 tw-border-blue-600'
                                                            : 'tw-bg-white tw-border-[#D5D7DA] group-hover:tw-border-blue-600'
                                                    }`}>
                                                        {filterBusinesses.has(b.id) && (
                                                            <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                                                                <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                        )}
                                                    </span>
                                                    <input 
                                                        type="checkbox"
                                                        checked={filterBusinesses.has(b.id)}
                                                        onChange={(e) => onBusinessFilterToggle(b.id, e.target.checked)}
                                                        className="tw-hidden"
                                                    />
                                                    <span className="tw-text-[13px] tw-text-[#414651] dark:tw-text-[#E2E8F0] tw-truncate">{b.name}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Separator */}
                                    <div className="tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB] dark:tw-border-white/10 tw-my-3"></div>

                                    {/* FUNCTION Section */}
                                    <div className="tw-mb-4">
                                        <label className="tw-block tw-text-[11px] tw-font-semibold tw-text-[#717680] dark:tw-text-[#B2B5BE] tw-uppercase tw-tracking-wider tw-mb-2">
                                            Function
                                        </label>
                                        <Select
                                            classNamePrefix="select-control"
                                            placeholder="All Functions"
                                            isClearable
                                            components={{
                                                ClearIndicator: (props) => (
                                                    <components.ClearIndicator {...props}>
                                                        <button class="btn btn-clear !tw-block !tw-right-[24px]" title="Clear"><i className="icon-close" style={{ cursor: 'pointer', fontSize: '12px', color: '#9CA3AF' }} /></button>
                                                    </components.ClearIndicator>
                                                )
                                            }}
                                            options={scopedFunctions.map(f => ({ value: f.id, label: f.name }))}
                                            value={
                                                filterFunctionId === 'all'
                                                    ? null
                                                    : scopedFunctions.map(f => ({ value: f.id, label: f.name })).find(o => o.value === filterFunctionId) || null
                                            }
                                            onChange={opt => onFunctionFilterChange(opt ? opt.value : 'all')}
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>

                                    {/* Separator */}
                                    <div className="tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB] dark:tw-border-white/10 tw-my-3"></div>

                                    {/* STATUS Section */}
                                    <div className="tw-mb-4">
                                        <label className="tw-block tw-text-[11px] tw-font-semibold tw-text-[#717680] dark:tw-text-[#B2B5BE] tw-uppercase tw-tracking-wider tw-mb-2">
                                            Status
                                        </label>
                                        <div className="tw-space-y-2 tw-flex tw-items-center tw-gap-3.5">
                                            {[
                                                { value: 'all', label: 'All' },
                                                { value: 'auto-mapped', label: 'Auto-mapped' },
                                                { value: 'manual', label: 'Manual' }
                                            ].map(option => (
                                                <label 
                                                    key={option.value} 
                                                    className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer !tw-m-0"
                                                >
                                                    <input 
                                                        type="radio" 
                                                        name="filterStatusRadio"
                                                        value={option.value}
                                                        checked={filterStatus === option.value}
                                                        onChange={() => onStatusFilterChange(option.value)}
                                                        className="tw-w-4 tw-h-4 tw-accent-blue-600 tw-cursor-pointer tw-flex-shrink-0"
                                                    />
                                                    <span className="tw-text-[13px] tw-text-[#414651] dark:tw-text-[#E2E8F0]">{option.label}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                {/* Footer */}
                                <div className="tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB] dark:tw-border-white/10 tw-px-4 tw-py-3 tw-flex tw-items-center tw-justify-between">
                                    <span className="tw-text-[12px] tw-text-[#717680] dark:tw-text-[#B2B5BE]">
                                        {matchingCount} mappings match
                                    </span>
                                    <button
                                        type="button"
                                        onClick={toggleFilterPanel}
                                        className="btn btn-primary tw-text-[13px] tw-font-semibold tw-rounded-lg tw-px-4 tw-py-[6px] tw-cursor-pointer"
                                    >
                                        Done
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Search Input */}
                    <div className="tw-relative tw-w-[750px]">
                        <span className="tw-absolute tw-left-3 tw-top-1/2 tw-translate-y-[-50%] tw-text-gray-400">
                            <Search size={16} />
                        </span>
                        <input
                            type="text"
                            placeholder="Search KPIs, business areas, assets..."
                            value={searchVal}
                            onChange={(e) => onSearchChange(e.target.value)}
                            className="tw-w-full tw-pl-10 tw-pr-4 tw-py-2 tw-text-sm tw-text-[#171717] dark:tw-text-white tw-bg-white dark:tw-bg-[#2B2B40] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-rounded-lg focus:tw-outline-none focus:tw-border-[#4F46E5] dark:focus:tw-border-[#818CF8]"
                        />
                    </div>

                    {/* Right-hand Controls (Layout Toggle and Add Button) */}
                    <div className="tw-flex tw-items-center tw-gap-3">
                        <button 
                            type="button"
                            onClick={onAddMappingClick}
                            className="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-bg-[#EF4444] hover:tw-bg-[#DC2626] tw-rounded-lg tw-transition-colors tw-border-none"
                        >
                            <Plus size={16} />
                            Add mapping
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default WorkspaceHeader;
